import { UPDATE_EMAIL_CAMPAIGNS } from "./keys";

const initialState = {
    emailData: []
}
export default function reducer(state = initialState, action) {

    switch (action.type) {
        case UPDATE_EMAIL_CAMPAIGNS: {
            return { ...state, emailData: action.payload }
        }

        default:
            return { ...state }
    }
}
